module.exports = __webpack_public_path__ + "img/hipaa.0910f016.png";